<template>
  <v-dialog
    v-model="show"
    width="1000px"
    transition="slide-x-reverse-transition"
    content-class="rounded-xl v-dialog-right"
  >
    <v-card rounded="xl" height="100%" max-height="100%" class="d-flex flex-column">

      <v-card-title>
        <v-icon left @click="show = false">
          fa-times
        </v-icon>
        Фильтрация списка

        <v-spacer/>

        <v-btn
          @click="filteredList"
          color="teal darken-3"
          class="white--text rounded-lg"
          elevation="0"
        >
          <v-icon small left>fa-filter</v-icon> Принять
        </v-btn>

      </v-card-title>

      <v-divider/>

      <div class="px-4">
        <v-form ref="formFilterTeacher">
          <v-row>
            <v-col>
              <v-radio-group
                v-model="radioBtnExamination"
                row
              >
                <v-radio
                  label="Не проверенные"
                  color="red"
                  :value="false"
                ></v-radio>
                <v-radio
                  label="Проверенные"
                  color="teal darken-3"
                  :value="true"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col>

            </v-col>
          </v-row>
        </v-form>
      </div>
      <v-divider v-show="arrayFilters.length >0"/>
      <div class="overflow-auto">
        <v-data-table
          :items="pathContracts"
          :headers="headers"
          v-model="arrayFilters"
          hide-default-footer
          disable-pagination
          fixed-header
          item-key="id"
          item-class="text-subtitle-1"
          show-select
          selectable-key="id"
        >
          <template #top>
            <v-tabs v-model="toggleTypeContracts">
              <v-tab key="bid">Оклад</v-tab>
              <v-tab key="headDepartment">Зав. кафедрой</v-tab>
              <v-tab key="dean">Декан</v-tab>
            </v-tabs>
            <v-divider/>
          </template>

          <template #item.kind="{item, index}">
            <v-chip small>
              {{ item.kind === "basic" ? "Базовая" : "Стимулирующая"}}
            </v-chip>
          </template>

          <template #item.is_publication="{item, index}">
            <v-icon v-if="item.is_publication" small>fa-check-circle</v-icon>
            <v-icon v-else small>fa-times-circle</v-icon>
          </template>

        </v-data-table>
      </div>
      <v-divider/>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiServices from "../services/api.services";
import _ from 'lodash'

export default {
  name: "TheFilterTeachersListDialog",

  data() {
    return {
      arrayFilters: [],
      listEffContracts: [],
      toggleTypeContracts: "bid",
      radioBtnExamination: false,
      headers: [
        {
          text: 'Наименование',
          value: 'indicator_name',
          groupable: false,
          sortable: false,
          class: "text-subtitle-1",
          divider: true,
        },
        {
          text: 'Часть',
          value: 'kind',
          groupable: false,
          sortable: false,
          class: "text-subtitle-1",
        },
        {
          text: 'Позиция',
          value: 'position',
          groupable: false,
          sortable: false,
          class: "text-subtitle-1",
        },
        {
          text: 'План',
          value: 'plan',
          groupable: false,
          sortable: false,
          class: "text-subtitle-1",
        },
        {
          text: 'Публикация?',
          value: 'is_publication',
          groupable: false,
          sortable: false,
          class: "text-subtitle-1",
        },
      ]
    };
  },

  watch: {
  },

  props: {
    visible: Boolean,
    parentFilters: Array,
  },


  mounted() {
    this.getListContracts();
  },

  computed: {

    show: {
      get() {
        this.setArrayFilters();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
          this.radioBtnExamination = false;
          this.toggleTypeContracts = 'bid';
        }
      }
    },

    unionListContracts() {
      return _.unionBy(this.listEffContracts, 'indicator_name')
    },

    pathContracts() {
      let type = "";

      switch (this.toggleTypeContracts) {
        case 0:
          type = "Оклад";
          break;
        case 1:
          type = "Заведующий кафедрой";
          break;
        case 2:
          type = "Декан";
          break;
        default:
          type = "Оклад"
      }
      return _.filter(this.unionListContracts, (o) => {return o.position === type})
    }

  },

  methods: {
    async getListContracts() {
      try {
        const response = await ApiServices.getEffContractsAll();
        return this.listEffContracts = response.data;
      } catch (e) {
        return console.log(e);
      }
    },

    filteredList() {
      this.$emit("filtered", _.map(this.arrayFilters, (o) => {return _.pick(o, ['indicator_name'])}), this.radioBtnExamination);
      this.show = false;
    },

    setArrayFilters() {
      this.arrayFilters = _.intersectionWith(this.unionListContracts, this.parentFilters, (i, num) => {
        return i.indicator_name === num.indicator_name;
      });
    },
  },

}
</script>

<style scoped>
>>> .v-dialog-right {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height:99%;
  max-height: 99%;
  min-height: 99%;
  overflow-y: auto;
  top: 5px;
  right: 8px;
}
</style>